import React, { useState, useCallback } from 'react';
import Toast from './Toast';

interface ChallengeModalProps {
  lifeExpectancy: number;
  resultTitle: string;
  quizId?: string;
  resultText?: string;
}

const ChallengeModal: React.FC<ChallengeModalProps> = ({
  lifeExpectancy,
  resultTitle,
  quizId,
  resultText,
}) => {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  const quizPath = quizId ? `/quiz/${quizId}` : '';
  const challengeUrl = `${window.location.origin}${quizPath}?challenge=${lifeExpectancy}`;
  const display = resultText || `${lifeExpectancy}살`;
  const challengeText = `나는 ${display}! "${resultTitle}" 등급이야. 너도 도전해봐!`;

  const showToastMsg = useCallback((msg: string) => {
    setToastMessage(msg);
    setShowToast(true);
  }, []);

  const handleChallenge = async () => {
    const fullText = `${challengeText}\n${challengeUrl}`;

    if (navigator.share) {
      try {
        await navigator.share({
          title: '건강 테스트 도전장!',
          text: challengeText,
          url: challengeUrl,
        });
        return;
      } catch (err: any) {
        if (err.name === 'AbortError') return;
      }
    }

    try {
      await navigator.clipboard.writeText(fullText);
      showToastMsg('도전장 링크가 복사되었습니다!');
    } catch {
      showToastMsg('복사에 실패했습니다.');
    }
  };

  return (
    <>
      <button
        onClick={handleChallenge}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          width: '100%',
          maxWidth: '280px',
          padding: '16px 20px',
          margin: '10px 0',
          border: '3px solid #FF6B6B',
          borderRadius: '16px',
          fontSize: '16px',
          fontWeight: 'bold',
          cursor: 'pointer',
          fontFamily: "'TTLaundryGothicB', sans-serif",
          backgroundColor: '#fff',
          color: '#FF6B6B',
          transition: 'all 0.3s',
          boxShadow: '0 4px 12px rgba(255,107,107,0.2)',
          float: 'none',
          minWidth: 'unset',
        }}
      >
        🔥 친구에게 도전장 보내기
      </button>

      <Toast message={toastMessage} show={showToast} onClose={() => setShowToast(false)} />
    </>
  );
};

export default ChallengeModal;
